// import axios from 'axios';
import { message } from 'antd';
import request from './request';
import { osintRequestAddress } from '../comps/config'

export const cordConvertEng = (lat, lon) => {
    var latStr, lonStr
    if (lat < 0) {
        latStr = "S"
    } else {
        latStr = "N"
    }
    if (lon < 0) {
        lonStr = "W"
    } else {
        lonStr = "E"
    }
    return Math.abs(lat.toFixed(2)).toString() + latStr + ", " + Math.abs(lon.toFixed(2)).toString() + lonStr
}


export const cordConvert = (lat, lon) => {
    if (!lat || !lon) {
        return ''
    }
    var latStr, lonStr
    if (lat < 0) {
        latStr = "南纬"
    } else {
        latStr = "北纬"
    }
    if (lon < 0) {
        lonStr = "西经"
    } else {
        lonStr = "东经"
    }
    return lonStr + Math.abs(lon.toFixed(2)).toString() + "度，" + latStr + Math.abs(lat.toFixed(2)).toString() + "度"
}

export const iconRotate = (original, rotateDegree) => {
    return (original + rotateDegree + 360) % 360;
}

export const translate = (t, setResult) => {
    request({
        url: `${osintRequestAddress}/trans`,
        method: 'post',
        data: { "language": "en", "content": t },
    }).then(res => {
        if (res && res.content) {
            setResult(res.content)
        }
    }).catch(err => {
        message.error(err.msg ? err.msg : '发生未知错误')
    })
}

export const dataFormat = (datastr) => {
    var date = new Date(datastr);
    var Y = date.getFullYear() + "-";
    var M =
    (date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1) + "-";
    var D =
    (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
    var h =
    (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
    var m =
    (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
    ":";
    var s =
    date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
    return Y + M + D + h + m + s;
}